import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ApiErrorFactory } from '../../core/api-errors';
import { SiteService } from '../../core/site';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-advanced-settings',
  templateUrl: './advanced-settings.component.html',
  styleUrls: ['./advanced-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, TranslateModule, MatSlideToggleModule, MatExpansionModule],
})
export class AdvancedSettingsComponent implements OnInit {
  upgradeToHttps$: Observable<boolean>;
  disabled$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  disabled$: Observable<boolean> = this.disabled$$.asObservable();

  constructor(
    private siteService: SiteService,
    private route: ActivatedRoute,
    private apiErrorFactory: ApiErrorFactory,
    private cdr: ChangeDetectorRef,
    private alertService: SnackbarService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.loadUpgradeToHttpsFlag();
  }

  loadUpgradeToHttpsFlag(): void {
    this.upgradeToHttps$ = this.siteService.getSkipHTTPSUpgradeFlag().pipe(
      take(1),
      catchError((error) => {
        this.handleError(error);
        return of(error);
      }),
      map((res) => {
        this.disabled$$.next(false);
        // The flag is the inverse of the slider in the UI
        return !res;
      }),
    );
    this.cdr.detectChanges();
  }

  toggleUpgradeToHttpsFlag(checked: boolean): void {
    this.disabled$$.next(true);
    /// The flag is the inverse of the slider in the UI
    this.siteService
      .setSkipHTTPSUpgradeFlag(!checked)
      .pipe(take(1))
      .subscribe(
        () => this.disabled$$.next(false),
        (error) => {
          this.handleError(error);
          return of(error);
        },
      );
  }

  handleError(errorResponse: HttpErrorResponse): void {
    this.disabled$$.next(true);
    const parsedError = this.apiErrorFactory.parseErrorResponse(errorResponse);
    this.alertService.openErrorSnack(
      parsedError.getUserMessage(),
      this.translateService.instant('ALERTS.GENERAL.DISMISS'),
    );
  }
}
